// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccessEnd } from './AccessEnd';
import {
    AccessEndFromJSON,
    AccessEndFromJSONTyped,
    AccessEndToJSON,
    AccessEndToJSONTyped,
} from './AccessEnd';
import type { Leg } from './Leg';
import {
    LegFromJSON,
    LegFromJSONTyped,
    LegToJSON,
    LegToJSONTyped,
} from './Leg';

/**
 * Movement of a user from one `Place` to another, where the `Trip` (aka Transmodel NON-PT Trip) is made entirely by personal means (for e.g. private car or walk), and neither of the endpoints is a `ScheduledStopPoint` or vehicle meeting point.<br>Inherited from `Leg`.
 * @export
 * @interface PersonalLeg
 */
export interface PersonalLeg extends Leg {
    /**
     * 
     * @type {AccessEnd}
     * @memberof PersonalLeg
     */
    start?: AccessEnd;
    /**
     * 
     * @type {AccessEnd}
     * @memberof PersonalLeg
     */
    end?: AccessEnd;
}

/**
 * Check if a given object implements the PersonalLeg interface.
 */
export function instanceOfPersonalLeg(value: object): value is PersonalLeg {
    return true;
}

export function PersonalLegFromJSON(json: any): PersonalLeg {
    return PersonalLegFromJSONTyped(json, false);
}

export function PersonalLegFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalLeg {
    if (json == null) {
        return json;
    }
    return {
        ...LegFromJSONTyped(json, true),
        'start': json['start'] == null ? undefined : AccessEndFromJSON(json['start']),
        'end': json['end'] == null ? undefined : AccessEndFromJSON(json['end']),
    };
}

  export function PersonalLegToJSON(json: any): PersonalLeg {
      return PersonalLegToJSONTyped(json, false);
  }

  export function PersonalLegToJSONTyped(value?: PersonalLeg | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...LegToJSONTyped(value, true),
        'start': AccessEndToJSON(value['start']),
        'end': AccessEndToJSON(value['end']),
    };
}

